import React from "react";

export function Bergle() {
  return (
    <span className="font-bold">
      <span className="text-amber-900">O</span><span className="text-amber-900">S</span><span className="text-amber-900">L</span>
      <span className="text-amber-900">O</span><span className="text-amber-900">L</span><span className="text-amber-900">E</span>
    </span>
  );
}
